const remove = (els) => {
	els.forEach((el) => {
		el.classList.remove('active');
	});
};
const add = (els) => {
	els.forEach((el) => {
		el.classList.add('active');
	});
};

const filter = () => {
	const urlParams = new URLSearchParams(window.location.search);
	const act = urlParams.get('act');
	if (act) {
		const element = document.querySelector('.js-blog-articles-c');
		if (element) {
			element.scrollIntoView({ behavior: 'smooth', block: 'start' });
		}
	}
	// const filterBtns = document.querySelectorAll('[data-filter-btn]');
	// filterBtns.forEach((el) => {
	// 	const btn = el;
	// 	btn.onclick = (e) => {
	// 		e.preventDefault();
	// 		const filterItems = document.querySelectorAll('[data-filter-item]');
	// 		const { filterBtn } = btn.dataset;
	// 		const items = document.querySelectorAll(`[data-filter-item="${filterBtn}"]`);
	// 		remove(filterItems);
	// 		remove(filterBtns);
	// 		if (filterBtn === 'all') {
	// 			add(filterItems);
	// 		} else {
	// 			add(items);
	// 		}
	// 		btn.classList.add('active');
	// 		const currentUrl = new URL(window.location.href);
	// 		currentUrl.searchParams.set('act', `${filterBtn}`);
	// 		window.history.replaceState({}, '', currentUrl);
	// };
	// });
};

export default filter;
